const FORM_DELETE_MANAGING_ROLES = [
  "super_admin",
  "admin",
  "sale",
  "accountant",
  "sleep_physician",
  "sleep_technician",
];

export const isStaffOnlyPatientFormUser = (roles = []) =>
  Array.isArray(roles) &&
  roles.includes("staff") &&
  !roles.some((role) => FORM_DELETE_MANAGING_ROLES.includes(role));

export const canDeletePatientForm = (roles = []) =>
  !isStaffOnlyPatientFormUser(roles);
